export default __webpack_public_path__ + "static/media/tophat2.e575bf9b.jpg";